import Phaser from 'phaser'
import { button } from '../ui/button'
import { THEME, hex } from '../../../kit/theme'
import { sfx } from '../../../kit/sfx'
import { HOLES } from '../../../core/holes'
import type { RoundResult } from '../../../hitz/TacadaLimpaHitzAdapter'

export class ResultScene extends Phaser.Scene {
  constructor() { super('Result') }

  create(data: RoundResult) {
    const { width, height } = this.scale
    this.cameras.main.setBackgroundColor(THEME.colors.bg)
    const f = (size: number, color: string = THEME.colors.text) => ({ fontFamily: THEME.font.family, fontSize: `${size}px`, color, fontStyle: 'bold' })
    sfx.play(data.won ? 'win' : 'lose')
    this.add.text(width / 2, height * 0.13, data.won ? 'Volta no par!' : 'Passou do par', f(64, data.won ? THEME.colors.positive : THEME.colors.text)).setOrigin(0.5)
    this.add.text(width / 2, height * 0.22, `${data.score} pts`, f(96, THEME.colors.accent)).setOrigin(0.5)
    this.add.text(width / 2, height * 0.29, `${data.strokes} tacadas · par ${data.par}${data.won ? '' : ' · pontuação zerada'}`, f(30, THEME.colors.textDim)).setOrigin(0.5)
    this.add.rectangle(width / 2, height * 0.45, 600, 330, hex('panel')).setStrokeStyle(4, hex('stone'))
    data.cards.forEach((c, i) => {
      const y = height * 0.36 + i * 95
      this.add.text(110, y, `${i + 1}. ${HOLES[c.id]?.name ?? c.id}`, f(34)).setOrigin(0, 0.5)
      this.add.text(width - 110, y, `${c.strokes}/${c.par}  +${c.points}`, f(34, c.strokes <= c.par ? THEME.colors.positive : THEME.colors.textDim)).setOrigin(1, 0.5)
    })
    button(this, width / 2, height * 0.68, 'JOGAR DE NOVO', () => this.scene.start('Game', { levelId: data.levelId }), { w: 520 })
    button(this, width / 2, height * 0.79, 'MENU', () => this.scene.start('Menu'), { w: 520, secondary: true })
  }
}
